import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Dropdown, DropdownButton, DropdownContent } from "@aviary";
import { QuickOrder } from "@emerson/components/QuickOrder/QuickOrder";
import { l } from "@emerson/locales/i18n";
import { AnalyticsEvent } from "@shared/hooks/useAnalyticsLogger/AnalyticsEvent";
import { useAnalyticsLogger } from "@shared/hooks/useAnalyticsLogger/useAnalyticsLogger";
import { useLocation } from "@shared/react-router-dom/react-router-dom";

import * as styles from "./QuickOrderButton.styles";

const QuickOrderButton = () => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { pathname } = useLocation();
  const logAnalyticsEvent = useAnalyticsLogger();

  const logOpenQuickOrderEvent = () => {
    logAnalyticsEvent({
      eventName: AnalyticsEvent.EMERSON_QUICK_ORDER_OPEN_QUICK_ORDER,
      payload: {
        page_url: pathname,
      },
    });
  };

  return (
    <Dropdown
      dropdownPlacement="bottom"
      isFullHeight
      closeOnExternalClick={!isModalOpen}
      triggerCallback={logOpenQuickOrderEvent}
    >
      <DropdownButton data-testid="emerson-quick-order-button" hasIcon={false}>
        {t(l.header.QuickOrder.Header)}
      </DropdownButton>
      <DropdownContent css={styles.content}>
        <QuickOrder setIsModalOpen={setIsModalOpen} />
      </DropdownContent>
    </Dropdown>
  );
};

export { QuickOrderButton };
